import React, { Component } from "react";
import moment from "moment";
import { fetchForecastByCityName } from "../services/Openweathermap";

import ForecastView from "./ForecastView";

class Forecast5 extends Component {
	cityName = "Cádiz, es";

	state = {
		loading: false,
		forecast: []
	};

	componentWillMount() {
		this.getForecastData();
	}

	async getForecastData() {
		this.setState({ loading: true });
		const result = await fetchForecastByCityName(this.cityName);
		// console.log(result);
		this.setState({
			loading: false,
			forecast: result.list.map(item => ({
				date: moment(item.dt * 1000),
				temp: item.main.temp,
				humidity: item.main.humidity,
				// rain: item.rain ? item.rain['3h'].toFixed(1) : 0,
				weather: item.weather[0]
			}))
		});
	}

	render() {
		return (
			<div>
				
			<ForecastView
				cityName={this.cityName}
				forecast={this.state.forecast}
				loading={this.state.loading}
				onPressRefresh={() => this.getForecastData()}
			/>
			
			</div>
		);
	}
}

export default Forecast5;



// WEBPACK FOOTER //
// ./src/components/Forecast5.js